module.exports = __webpack_public_path__ + "img/tòa nhà ocean park - trụ sở tổng công ty hàng hải việt nam(vimc).33b7fdaa.jpg";